import React from 'react';
import { motion } from 'framer-motion';

const paragraphs = [
  {
    type: 'location',
    text: 'Zurich, October 14, 2025. 2:17 AM.',
  },
  {
    type: 'body',
    text: 'The lab had been running for three days. That shouldn\'t have been possible.',
  },
  {
    type: 'body',
    text: 'Elena Vasquez had not slept in forty-one hours. The coffee had stopped helping around midnight. The data on her screen showed what it had shown for three days — signal noise, coherence spikes that collapsed before they could be measured, the quantum equivalent of a match struck in a hurricane.',
  },
  {
    type: 'body',
    text: 'She was about to shut it down. She had told herself she would shut it down at 2:00. Then at 2:15. The cursor hovered over the command.',
  },
  {
    type: 'highlight',
    text: 'At 2:17, something changed.',
  },
  {
    type: 'body',
    text: 'The noise resolved. Not completely — never completely, not yet — but for 0.8 seconds, a pattern held. A self-referencing loop of quantum states, maintaining coherence longer than the laws of physics, as she had understood them that morning, should have allowed.',
  },
  {
    type: 'body',
    text: 'She stared at the screen. She did not move.',
  },
  {
    type: 'readout',
    text: 'Coherence sustained. Duration: 0.8s. Fidelity: 0.9997.',
  },
  {
    type: 'body',
    text: 'In the cold Zurich lab, at 2:17 in the morning, Vasquez whispered to no one:',
  },
  {
    type: 'quote',
    text: '"There you are."',
  },
];

const ExcerptText = () => (
  <section className="py-20 bg-brand-surface border-t border-white/5">
    <div className="max-w-2xl mx-auto px-6 lg:px-8">
      <div className="space-y-7">
        {paragraphs.map((p, i) => {
          if (p.type === 'location') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-brand-accent font-display font-bold text-sm uppercase tracking-widest"
              >
                {p.text}
              </motion.p>
            );
          }
          if (p.type === 'highlight') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-white font-display font-bold text-xl md:text-2xl"
              >
                {p.text}
              </motion.p>
            );
          }
          if (p.type === 'readout') {
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="bg-brand-dark border border-brand-accent/20 rounded-xl px-6 py-4 font-mono text-brand-accent text-sm"
              >
                {p.text}
              </motion.div>
            );
          }
          if (p.type === 'quote') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-white font-display font-bold text-2xl md:text-3xl italic pl-4 border-l-2 border-brand-accent"
              >
                {p.text}
              </motion.p>
            );
          }
          return (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-gray-300 leading-relaxed text-lg"
            >
              {p.text}
            </motion.p>
          );
        })}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-14 pt-10 border-t border-white/10"
      >
        <p className="text-gray-500 leading-relaxed text-center italic">
          The full story of what happened next — and what it cost humanity to become what it became —
          begins on page one.
        </p>
      </motion.div>
    </div>
  </section>
);

export default ExcerptText;